import { InjectionToken } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';

// Keys used for date-input scope (merged under alias "date")
export const MONTH_KEYS = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec',
] as const;
export const DAY_KEYS = [
  'sun',
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
] as const;

/** Date-only display format (no time) for the input when showTime is false */
export const OMM_DATE_ONLY_DISPLAY = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
} as const;

/** Date + time display format for the input when showTime is true */
export const OMM_DATE_TIME_DISPLAY = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
} as const;

/** Time-only display format for the input when timeOnly is true */
export const OMM_TIME_ONLY_DISPLAY = {
  hour: '2-digit',
  minute: '2-digit',
} as const;

/** Mutable options for date-input; component sets flags so MAT_DATE_FORMATS can pick display */
export const DATE_INPUT_OPTIONS = new InjectionToken<{
  showTime: boolean;
  timeOnly: boolean;
}>('DATE_INPUT_OPTIONS');

export const OMM_DATE_TIME_INPUT_FORMATS: MatDateFormats = {
  parse: { dateInput: null, timeInput: null },
  display: {
    dateInput: OMM_DATE_TIME_DISPLAY,
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
    timeInput: { hour: 'numeric', minute: 'numeric' },
    timeOptionLabel: { hour: 'numeric', minute: 'numeric' },
  },
};
